
import {
  Component, Mixins, Prop, Watch,
} from 'vue-property-decorator'

import ValidatorMixin from '@/shared/mixins/validator/ValidatorMixin'

import CheckoutForm from '../models/CheckoutForm'
import Zipcode from '../models/Zipcode'

import zipcodeService from '../network/service/zipcode.service'

import EButton from './Button.vue'
import EInput from './Input.vue'
import ESelect from './Select.vue'

@Component({
  components: {
    EButton,
    EInput,
    ESelect,
  },
})
export default class AddressForm extends Mixins(ValidatorMixin) {
  @Prop() readonly data!: CheckoutForm

  address = this.data.address;

  isFetching = false

  disableEdition = false

  readonly countries = [
    { name: this.$t('message.countries.BR'), code: 'BR' },
    { name: this.$t('message.countries.MX'), code: 'MX' },
  ]

  partialAddress = this.data.partialAddress;

  partialEdition = false

  @Prop({ type: Boolean, default: false }) readonly autoSearch!: boolean

  @Watch('data.address.zipCode', { deep: true })
  private async searchByZipCode(val = '') {
    if (!this.autoSearch || val.length < 8) {
      return
    }

    this.isFetching = true
    this.resetValidation()
    this.resetAddress()

    try {
      const address = await zipcodeService.searchBy(val)
      this.disableEdition = true
      this.partialEdition = !address.main || !address.locality
      this.setAddress(address)
    } catch (error) {
      this.disableEdition = false
    } finally {
      this.isFetching = false
    }
  }

  private setAddress(address: Zipcode) {
    Object.assign(this.address, {
      main: address.main,
      locality: address.locality,
      state: address.state,
      city: address.city,
    })
  }

  private resetAddress() {
    Object.assign(this.address, {
      main: '',
      locality: '',
      state: '',
      city: '',
      additional: '',
      number: undefined,
    })
  }

  mounted() {
    if (this.address.isIncomplete) {
      this.searchByZipCode(this.address.zipCode)
    }
  }
}
